import React from 'react';
import {
  Actions,
  Subjects,
  useUserAbilitiesContext,
} from 'context/user/UserContext';

/** Renders `children` when the signed-in user has the `debug` feature. */
export default function Debug({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement | null {
  const ability = useUserAbilitiesContext();

  if (!ability.can(Actions.UseFeature, Subjects.Debug)) {
    return null;
  }

  const childArray = React.Children.toArray(children).filter(
    React.isValidElement
  );
  if (childArray.length === 0) {
    return null;
  }
  if (childArray.length === 1) {
    return childArray[0];
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment -- multiple debug children
  return <>{childArray}</>;
}
